import React, { useRef } from 'react';

const AnnouncementDetail: React.FC = () => {
  const conditionRef = useRef<HTMLDivElement | null>(null);
  const detailRef = useRef<HTMLDivElement | null>(null);
  const companyRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = (ref: React.RefObject<HTMLDivElement | null>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div style={{ background: '#f8f8e7', minHeight: '100vh', padding: '40px 0' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        {/* 상단 버튼 */}
        <div style={{ display: 'flex', borderBottom: '2px solid #eee', marginBottom: 40 }}>
          <button
            style={{ flex: 1, padding: '24px 0 18px 0', fontSize: 20, fontWeight: 600, color: '#ff7f32', background: 'none', border: 'none', borderBottom: '4px solid #ff7f32', cursor: 'pointer' }}
            onClick={() => handleScroll(conditionRef)}
          >
            근무조건
          </button>
          <button
            style={{ flex: 1, padding: '24px 0 18px 0', fontSize: 20, fontWeight: 600, color: '#ff7f32', background: 'none', border: 'none', borderBottom: '4px solid #ff7f32', cursor: 'pointer' }}
            onClick={() => handleScroll(detailRef)}
          >
            상세요강
          </button>
          <button
            style={{ flex: 1, padding: '24px 0 18px 0', fontSize: 20, fontWeight: 600, color: '#ff7f32', background: 'none', border: 'none', borderBottom: '4px solid #ff7f32', cursor: 'pointer' }}
            onClick={() => handleScroll(companyRef)}
          >
            기업정보
          </button>
        </div>

        {/* 세 섹션이 아래로 쭉 나열 */}
        <div ref={conditionRef} style={{ background: '#fff', borderRadius: 16, padding: 48, minHeight: 220, marginBottom: 48, boxShadow: '0 4px 16px rgba(0,0,0,0.06)' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24, color: '#222' }}>근무조건</h2>
        </div>
        <div ref={detailRef} style={{ background: '#fff', borderRadius: 16, padding: 48, minHeight: 220, marginBottom: 48, boxShadow: '0 4px 16px rgba(0,0,0,0.06)' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24, color: '#222' }}>상세요강</h2>
        </div>
        <div ref={companyRef} style={{ background: '#fff', borderRadius: 16, padding: 48, minHeight: 220, marginBottom: 48, boxShadow: '0 4px 16px rgba(0,0,0,0.06)' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24, color: '#222' }}>기업정보</h2>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetail;
